import platformTypes from 'helpers/enums/platformTypes'

const userAgent = navigator ? navigator.userAgent : ''
const platform = userAgent.indexOf('AndroidApp') === -1 ? platformTypes.WEB : platformTypes.ANDROID

export default platform
